import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { UncontrolledTable } from '~/components';
import { CardSubtitle } from 'reactstrap';

// Stripping out all things that are in parens
// source of data has that, but client does NOT
// want to see it at all ... consider removing this
// Cell once client count goes up
const GalCasaName = ({ value = '' }) => (
  <>{(value || '').replace(/ *\([^)]*\) */g, ' ')}</>
);

GalCasaName.propTypes = {
  value: PropTypes.string.isRequired,
};

const Placement = () => {
  const params = useParams();

  return (
    <React.Fragment>
      <CardSubtitle tag="h5" className="m-3">
        Placement
      </CardSubtitle>

      <UncontrolledTable
        name="placement"
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-source-child',
          params: {
            patient_uid: params.patient_id,
            'all-data': '1',
          },
        }}
        columns={[
          {
            id: 'placementType',
            Header: 'Type',
            accessor: 'attributes.placementType',
          },
          {
            id: 'providerName',
            Header: 'Provider',
            accessor: 'attributes.providerName',
          },
          {
            id: 'providerContact',
            Header: 'Contact',
            accessor: 'attributes.providerContact',
            cellType: 'tel',
          },
          {
            id: 'providerAddress',
            Header: 'Address',
            accessor: 'attributes.providerAddress',
          },
        ]}
      />

      <br />

      <UncontrolledTable
        name="placement-agency"
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-tbl-source-child',
          params: {
            patient_uid: params.patient_id,
            'all-data': '1',
          },
        }}
        columns={[
          {
            id: 'providerAgency',
            Header: 'Placement Agency',
            accessor: 'attributes.providerAgency',
          },
          {
            id: 'thing',
            Header: '',
            accessor: 'thing',
          },
          {
            id: 'providerAgencyContact',
            Header: 'Contact',
            accessor: 'attributes.providerAgencyContact',
            cellType: 'tel',
          },
          {
            id: 'providerAgencyAddress',
            Header: 'Address',
            accessor: 'attributes.providerAgencyAddress',
          },
        ]}
      />

      <CardSubtitle tag="h5" className="m-3">
        GAL / CASA
      </CardSubtitle>

      <UncontrolledTable
        name="gal-casa"
        className="mx-4"
        endpoint={{
          url: 'data/public/list-view-cs-placement-and-court',
          params: {
            patient_uid: params.patient_id,
            'all-data': '1',
          },
        }}
        columns={[
          {
            id: 'galCasaName',
            Header: 'Name',
            accessor: 'attributes.galCasaName',
            Cell: GalCasaName,
          },
          {
            id: 'thing',
            Header: '',
            accessor: 'thing',
          },
          {
            id: 'galCasaContact',
            Header: 'Primary Contact',
            accessor: 'attributes.galCasaContact',
            cellType: 'tel', // TODO this could be phone OR email
          },
          {
            id: 'galCasaEmail',
            Header: 'Email',
            accessor: 'attributes.galCasaEmail',
            cellType: 'email',
          },
        ]}
      />
    </React.Fragment>
  );
};

export default Placement;
